const AIRPORT_TERMINALS = {
  LHR: ["2", "3", "4", "5"],
};

export const getAirportTerminals = (airportIATA) => {
  if (!airportIATA) return [];
  const code = String(airportIATA).trim().toUpperCase();
  return AIRPORT_TERMINALS[code] || [];
};

export default AIRPORT_TERMINALS;
